import React, { Component } from 'react';
import Page from '../../../containers/page';

import {
    Container,
    Row,
    Col,
    Modal, ModalHeader, ModalBody, ModalFooter, Button, Input
} from 'reactstrap';

import Isvg from 'react-inlinesvg'

import { API_ENDPOINT } from '../../../constants';
import xIcon from '../../../assets/svg/x.svg';
import FormGroup from 'reactstrap/lib/FormGroup';
import Label from 'reactstrap/lib/Label';
import { Player } from "@lottiefiles/react-lottie-player";
import moment from 'moment';
import notesIcon from '../../../assets/svg/notes-icon.svg';
import attachInvoice from '../../../assets/svg/attach.svg'

import checkIcon from '../../../assets/svg/check-icon.svg';
import calendar from '../../../assets/svg/calendar.svg';
import clockIcon from '../../../assets/svg/clock-icon.svg'





import Checkbox from '../../../components/forms/fields/checkbox';
import { getDetailedGroupPaymentMethods, getGroupPaymentMethods, getHumanReadable, getHumanReadableReasonForChange, getReasonsForChange } from '../helper';
import ErrorModal from '../../../components/errorModal';
import InfoModal from '../../../components/infoModal';
import FreeCardDetails from './freeCardDetails';
import SwishModal from './swishModal';
import PaysonModal from './paysonModal';
import StripeModal from './stripeModal';


function parseText(response) {
    return response.text().then(text => {
        return {
            result: text,
            status: response.status
        }
    })
}
function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}
class PayModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props.initialData,
            form: {
            },
            groupPaymentMethods: [],
        };
    }
    getCurrency = () => {
        return this.props.currency ? this.props.currency : typeof window !== 'undefined' && localStorage?.getItem("currency") ? localStorage.getItem("currency") : '';
    }


    checkPaymentMethods = () => {
        const groupData = this.state.groupData;

        const paymentMethods = getDetailedGroupPaymentMethods(groupData, this.props.lang);
        let setObj = { groupPaymentMethods: paymentMethods };

        this.setState(setObj)
    }


    get = () => {

    }
    getPaymentData = async () => {
        const caseId = this.props.caseId?.length === 24 ? this.props.caseId : null;
        let _paymentId = null;
        let items;
        if (caseId) {
            try {
                let response = await fetch(API_ENDPOINT + `/api/payments/case/${caseId}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                        'content-type': 'application/json'
                    }
                });
                let { result, status } = await parseJSON(response);
                items = result?.items?.length ? result?.items : [];
                const unpaidItems = items.filter(item => item?.currentStatus?.status?.key === 'UNPAID' && !['invoice', 'paymentOnSite', 'freeCard'].includes(item?.currentStatus?.paymentMethod?.key));
                if (unpaidItems?.[0]?._id) {
                    _paymentId = unpaidItems[0]._id;
                }
                if (caseId && !_paymentId) {
                    let paymentWithAutoRequestedInvoice = items.filter(item => item?.currentStatus?.status?.key === 'UNPAID' && ['invoice'].includes(item?.currentStatus?.paymentMethod?.key));
                    if (paymentWithAutoRequestedInvoice?.length) {
                        this.setSuccessModal('Once the invoice is created, it will be delivered to your email address, and you will also be able to download it on the "My payments" page.', 'invoice')
                        return;
                    }
                }
            } catch (error) {
                console.log('Error fetching payment by case', error);
            }
        }
        const paymentId = _paymentId?.length === 24 ? _paymentId : this.props.isOpen?.length === 24 ? this.props.isOpen : null;
        if (paymentId) {
            fetch(API_ENDPOINT + `/api/patient/payments/${paymentId}`, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(res => res.json()).then((result) => {
                const paymentData = result?.paymentData ?? null;
                const caseData = result?.caseData ?? null;
                const groupData = result?.groupData ?? null;
                const eventData = result?.eventData ?? null;
                console.log('paymentData', paymentData)

                if (!paymentData || paymentData?.currentStatus?.status?.key !== 'UNPAID') {
                    this.onClose(null, true);
                    return;
                }
                this.setState({ paymentData: paymentData, caseData: caseData, groupData: groupData, eventData: eventData }, () => {
                    this.checkPaymentMethods();
                })
            })
        } else {
            this.onClose(null, true);
        }
    }

    componentDidMount() {
        this.get();
        this.getPaymentData();
    }

    componentWillUnmount() {
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.lang !== prevProps.lang && this.state.groupData) {
            this.checkPaymentMethods();
        }

    }

    redirectToLink = (link = '/my-data/patient/payments', state = {}) => {
        this.props[0].history.push({
            pathname: link,
            state: state
        });
    }

    onClose = (callback, error = false) => {
        if (error) {
            if (this.props.paymentOnCaseSubmit && this.props.caseId) {
                const { paymentData, caseData } = this.state;
                const { wayOfScheduling, paymentBeforeSubmission, paymentBeforeBookedTime, paymentAfterBookedTime, paymentAfterSubmission } = caseData ?? {};

                let abortPaymentModal = {
                    message: null,
                    callback: null
                };
                let removeCaseModal;
                if (paymentBeforeSubmission || (wayOfScheduling === 'dropIn' && !paymentAfterSubmission)) {
                    removeCaseModal = caseData?._id;
                }
                if (wayOfScheduling === 'bookingByClinic') {
                    if (paymentBeforeBookedTime) {
                        abortPaymentModal.message = 'Your case has been submitted. The payment must be completed before we can approve your case.';
                        abortPaymentModal.callback = () => {
                            this.redirectToLink();
                        };
                    } else if (paymentAfterBookedTime) {
                        abortPaymentModal.message = 'Your case has been submitted. You will be prompted to complete payment when the case is approved by us.';
                        abortPaymentModal.callback = () => {
                            this.redirectToLink();
                        };
                    }
                } else if (wayOfScheduling === 'dropIn') {
                    if (paymentAfterSubmission) {
                        abortPaymentModal.message = 'Payment failed, please make sure to pay before your appointment.';
                        abortPaymentModal.callback = () => {
                            this.redirectToLink();
                        };
                    }
                } else if (wayOfScheduling === 'webBooking') {
                    if (!paymentBeforeSubmission) {
                        abortPaymentModal.message = 'Payment failed, please make sure to pay before your scheduled visit.';
                        abortPaymentModal.callback = () => {
                            this.redirectToLink();
                        };
                    }
                }

                if (abortPaymentModal.message) {
                    this.setState({ abortPaymentModal })
                } else if (removeCaseModal) {
                    this.setState({ removeCaseModal })
                }

            } else {
                this.setState({ closeError: "Payment failed, please make sure to pay before your scheduled visit." })
            }
        } else {
            if (this.props.onClose) {
                this.props.onClose(callback);
            }
        }

    }

    requestPaymentOnSite = (paymentId) => {
        if (!paymentId || paymentId?.length !== 24) return;

        const data = {};

        this.setState({ loading: true }, () => {
            fetch(API_ENDPOINT + `/api/patient/payments/payment-on-site/${paymentId}`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(parseJSON).then(({ result, status }) => {
                this.setState({ loading: false }, () => {
                    if (result?.error) {
                        this.setState({ error: result?.error })
                    } else if (result?.success) {
                        this.setSuccessModal('Payment must be made "On site" before the visit.', 'paymentOnSite')
                    }
                })
            })
        })
    }

    requestInvoice = (paymentId) => {
        if (!paymentId || paymentId?.length !== 24) return;

        const data = {};

        this.setState({ loading: true }, () => {
            fetch(API_ENDPOINT + `/api/patient/payments/request-invoice/${paymentId}`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(parseJSON).then(({ result, status }) => {
                this.setState({ loading: false }, () => {
                    if (result?.error) {
                        this.setState({ error: result?.error })
                    } else if (result?.success) {
                        this.setSuccessModal('Once the invoice is created, it will be delivered to your email address, and you will also be able to download it on the "My payments" page.', 'invoice')
                    }
                })
            })
        })
    }

    payWithFreeCard = (paymentId) => {
        if (!paymentId || paymentId?.length !== 24) return;

        let freeCardData = { ...this.state.freeCardData };
        if (!freeCardData || freeCardData?.errorExists) {
            this.setState({ showErrorsFreeCard: true });
            return;
        }
        delete freeCardData?.errorExists;
        const data = {
            freeCardData
        };
        this.setState({ loading: true }, () => {
            fetch(API_ENDPOINT + `/api/patient/payments/pay-with-free-card/${paymentId}`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(parseJSON).then(({ result, status }) => {
                this.setState({ loading: false }, () => {
                    if (result?.error) {
                        this.setState({ error: result?.error })
                    } else if (result?.success) {
                        this.setSuccessModal('Remember to take your free card with you.', 'freeCard')
                    }
                })
            })
        })
    }
    setSuccessModal = (message = '', paymentMethod) => {
        let successModal = {
            message: message,
            callback: null
        }
        if (this.props.paymentOnCaseSubmit && this.props.caseId) {
            const { paymentData, caseData } = this.state;
            const { wayOfScheduling, paymentBeforeSubmission, paymentBeforeBookedTime, paymentAfterBookedTime } = caseData ?? {};
            let isCasePaymentBeforeSubmission = paymentBeforeSubmission;
            if (!isCasePaymentBeforeSubmission && caseData?.wayOfScheduling === 'dropIn' && !caseData?.paymentAfterSubmission && caseData?.questionaryPrice > 0) isCasePaymentBeforeSubmission = true;

            if (isCasePaymentBeforeSubmission && caseData?._id) {
                if (this.props.trackFormSubission) this.props.trackFormSubission(caseData);
            }


            successModal.callback = () => {
                this.redirectToLink();
            };
            if (wayOfScheduling === 'bookingByClinic') {
                if (paymentMethod === 'invoice') {
                    successModal.message = 'Your case has been submitted successfully. Once the invoice is created, it will be delivered to your email address, and you will also be able to download it on the "My payments" page.';
                } else if (paymentMethod === 'paymentOnSite') {
                    successModal.message = 'Your case has been submitted successfully. Payment must be made "On site" before the visit.';
                } else if (paymentMethod === 'freeCard') {
                    successModal.message = 'Your case has been submitted successfully. Remember to take your free card with you.';
                } else if (['swish', 'payson', 'stripe'].includes(paymentMethod)) {
                    successModal.message = 'Your case has been submitted and payment has been made successfully.';
                }
            } else if (wayOfScheduling === 'dropIn') {
                if (paymentMethod === 'invoice') {
                    successModal.message = 'You have successfully scheduled a visit. Once the invoice is created, it will be delivered to your email address, and you will also be able to download it on the "My payments" page.';
                } else if (paymentMethod === 'freeCard') {
                    successModal.message = 'Your case has been submitted successfully. Please remain online and track the status of your case';
                } else if (['swish', 'payson', 'stripe'].includes(paymentMethod)) {
                    successModal.message = 'Your case has been submitted and payment has been made successfully. Please remain online and track the status of your case.';
                }
            } else if (wayOfScheduling === 'webBooking') {
                if (paymentMethod === 'invoice') {
                    successModal.message = 'You have successfully scheduled a visit. Once the invoice is created, it will be delivered to your email address, and you will also be able to download it on the "My payments" page.';
                } else if (paymentMethod === 'paymentOnSite') {
                    successModal.message = 'You have successfully scheduled a visit. Payment must be made "On site" before the visit.';
                } else if (paymentMethod === 'freeCard') {
                    successModal.message = 'You have successfully scheduled a visit. Remember to take your free card with you.';
                } else if (['swish', 'payson', 'stripe'].includes(paymentMethod)) {
                    successModal.message = 'Payment successful.';
                }
            }
        }


        this.setState({ successModal }, () => {
            this.props.verifyUser();
        })
    }
    openSwishModal = (paymentId) => {
        this.setState({ swishModal: paymentId });
    }
    openPaysonModal = (paymentId) => {
        this.setState({ paysonModal: paymentId });
    }

    openStripeModal = (paymentId) => {
        this.setState({ stripeModal: paymentId });
    }
    sendRequest = () => {
        const paymentData = this.state.paymentData;
        const paymentId = paymentData?._id ?? null;
        const selectedMethod = this.state.selectedMethod;

        if (!paymentId || !selectedMethod) return;

        if (selectedMethod === 'paymentOnSite') this.requestPaymentOnSite(paymentId);
        else if (selectedMethod === 'invoice') this.requestInvoice(paymentId);
        else if (selectedMethod === 'freeCard') this.payWithFreeCard(paymentId);
        else if (selectedMethod === 'swish') this.openSwishModal(paymentId);
        else if (selectedMethod === 'payson') this.openPaysonModal(paymentId);
        else if (selectedMethod === 'stripe') this.openStripeModal(paymentId);
    }


    getBasicInfo = () => {
        const { paymentData, caseData, groupData, eventData } = this.state;

        const currency = this.getCurrency();
        const _dateFormat = paymentData?.caseData?.visitDate?.hideTimeFromThePatient ? this.props.dateFormat : `${this.props.dateFormat} HH:mm`;
        const _visitDateTs = paymentData?.caseData?.visitDate?.ts ?? null;
        const visitDate = _visitDateTs ? this.props.getStringDateTs(_visitDateTs, _dateFormat) : null;
        const doctorName = paymentData?.caseData?.doctorName ? paymentData?.caseData?.doctorName : !paymentData?.caseData && paymentData?.createdByUser?.name ? paymentData?.createdByUser?.name : null;
        const questionaryName = paymentData?.caseData?.questionaryName ?? '';
        const caseNumber = paymentData?.paymentNumber ?? '';
        const patientName = paymentData?.patientData?.name ?? '';
        const patientSSN = paymentData?.patientData?.ssn ?? '';
        const price = `${paymentData?.amount?.value} ${paymentData?.amount?.currency ?? currency}`;

        let duration;
        if (eventData?.startTime && eventData?.endTime) {
            duration = Math.floor((eventData?.endTime - eventData?.startTime) / 60);
        }
        if (!duration && caseData?.questionaryDuration) {
            duration = caseData?.questionaryDuration;
        }
        if (caseData?.wayOfScheduling !== 'webBooking') {
            duration = null;
        }


        const questionaryDuration = duration ?? null;

        let response = {
            questionaryName: questionaryName,
            price: price,
            caseNumber: caseNumber,
            patientName: patientName,
            patientSSN: patientSSN,
            visitDate: visitDate,
            doctorName: doctorName,
            questionaryDuration: questionaryDuration
        };

        return response;
    }
    getPaymentMethods = () => {
        const groupPaymentMethods = this.state.groupPaymentMethods ?? [];
        const paymentData = this.state.paymentData;
        const allowedPaymentMethods = paymentData?.paymentMethods ?? [];

        const attachedInvoice = paymentData?.attachedInvoice ?? false;
        let response = [];
        for (let i = 0; i < groupPaymentMethods.length; i++) {
            let type = groupPaymentMethods[i]?.type;
            if (['stripe', 'payson', 'swish'].includes(type)) {
                type = 'onlinePayment';
            }
            if (allowedPaymentMethods.includes(type)) {
                let method = { ...groupPaymentMethods[i] };
                if (type === 'invoice' && attachedInvoice) {
                    method.disabled = true;
                }
                response.push(method);
            }
        }
        return response;
    }
    removeUnpaidCase = () => {
        const caseId = this.props.caseId?.length === 24 ? this.props.caseId : this.state.removeCaseModal ?? null
        const groupAlias = this.state.groupData?.alias ? this.state.groupData?.alias : typeof window !== 'undefined' && localStorage?.getItem("groupAlias") ? localStorage.getItem("groupAlias") : null;
        if (!caseId) {
            if (groupAlias) {
                this.redirectToLink(`/${groupAlias}`);
            }
            return;
        }

        this.setState({ loadingRemoveCase: true }, () => {
            fetch(API_ENDPOINT + `/api/patient/payments/delete-unpaid-case/${caseId}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(res => res.json()).then((result) => {
                this.setState({ loadingRemoveCase: false }, () => {
                    if (groupAlias) {
                        this.redirectToLink(`/${groupAlias}`);
                    }
                });
            });
        });
    }
    render() {
        const isOpen = this.props.isOpen &&
            !this.state.closeError &&
            !this.state.successModal &&
            !this.state.swishModal &&
            !this.state.paysonModal &&
            !this.state.stripeModal &&
            !this.state.abortPaymentModal &&
            !this.state.removeCaseModal;


        const paymentData = this.state.paymentData;

        if (!paymentData && !this.state.successModal) {
            return null;
        }


        const paymentMethods = this.getPaymentMethods();

        const basicInfo = this.getBasicInfo();
        return (
            <>
                <Modal isOpen={isOpen} centered className='pay-modal-wrap'>
                    <ModalHeader
                        toggle={() => this.onClose(null, true)}
                        close={
                            <button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.onClose(null, true)}>&times;</button>
                        }
                    >
                        {'Pay now'.translate(this.props.lang)}

                    </ModalHeader>

                    <ModalBody className='pay-modal-body'>
                        <Row>
                            <Col lg='12'>
                                <div className='basic-info-wrap'>
                                    {
                                        basicInfo?.visitDate ?
                                            <div className='info-item'>
                                                <div className='icon-wrap'>
                                                    <Isvg src={calendar} />
                                                </div>
                                                <div className='text-wrap'>
                                                    <div className='text-item' style={{ display: 'flex', gap: 10 }}>
                                                        <span>{basicInfo.visitDate}</span>
                                                        <span className='sub-text'>{"Timezone: Stockholm".translate(this.props.lang)}</span>
                                                    </div>
                                                    {
                                                        basicInfo?.doctorName ?
                                                            <div className='text-item'>
                                                                <span>{basicInfo.doctorName}</span>
                                                            </div>
                                                            :
                                                            null
                                                    }
                                                </div>
                                            </div>
                                            :
                                            null
                                    }
                                    {
                                        basicInfo?.questionaryName || (!basicInfo?.visitDate && basicInfo?.doctorName) ?
                                            <div className='info-item'>
                                                <div className='icon-wrap'>
                                                    <Isvg src={checkIcon} />
                                                </div>
                                                <div className='text-wrap'>
                                                    <div className='text-item'>
                                                        <span>{basicInfo.questionaryName}</span>
                                                    </div>
                                                    {
                                                        basicInfo?.questionaryDuration ?
                                                            <div className='text-item'>
                                                                <span className='sub-text'>{`${basicInfo.questionaryDuration} ${'min'.translate(this.props.lang)}`}</span>
                                                            </div>
                                                            :
                                                            null
                                                    }
                                                    {
                                                        !basicInfo?.visitDate && basicInfo?.doctorName ?
                                                            <div className='text-item'>
                                                                <span>{basicInfo.doctorName}</span>
                                                            </div>
                                                            :
                                                            null
                                                    }
                                                </div>
                                            </div>
                                            :
                                            null
                                    }
                                </div>
                            </Col>
                            <Col lg='12'>
                                {
                                    paymentMethods?.length ?
                                        <div className='payment-methods-wrap'>
                                            <div className='payment-methods-title'>{'Choose payment method'.translate(this.props.lang)}</div>
                                            <div className='methods-list'>
                                                {
                                                    paymentMethods.map((method, index) => {
                                                        const isSelected = this.state.selectedMethod === method.type;
                                                        const isDisabled = method.disabled ?? false;
                                                        return (
                                                            <div className={isDisabled ? 'method-item method-item-disabled' : isSelected ? 'method-item method-item-selected' : 'method-item'}
                                                                key={index}
                                                                onClick={() => {
                                                                    if (isDisabled) return;
                                                                    let selectedMethod = method.type;
                                                                    if (selectedMethod !== this.state.selectedMethod) {
                                                                        this.setState({ selectedMethod });
                                                                    }
                                                                }}
                                                            >
                                                                <div className='text-wrap'>
                                                                    <div className='radio-input-wrap'>
                                                                        {isSelected ? <div className='radio-selected'></div> : null}
                                                                    </div>
                                                                    <span>{method.label}</span>
                                                                </div>
                                                                {
                                                                    method.icon ?
                                                                        <div className='icon-wrap'>
                                                                            <Isvg src={method.icon} />
                                                                        </div>
                                                                        :
                                                                        null
                                                                }

                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                        :
                                        <div className='no-payment-methods'>{'No payment methods available'.translate(this.props.lang)}</div>
                                }
                                {
                                    this.state.selectedMethod === 'freeCard' ?
                                        <FreeCardDetails
                                            {...this.props}
                                            onChange={(data) => {
                                                this.setState({ freeCardData: data });
                                            }}
                                            showErrors={this.state.showErrorsFreeCard}
                                            handleShowErrors={(value) => {
                                                this.setState({ showErrorsFreeCard: value });
                                            }}
                                        />
                                        :
                                        null
                                }
                            </Col>

                            <Col lg='12'>
                                <div className='total-price-wrap'>
                                    <div className='total-price'>{basicInfo?.price}</div>
                                </div>
                            </Col>

                        </Row>





                    </ModalBody>
                    <ModalFooter className='modal-footer-buttons-wrap'>
                        <Button
                            color="primary"
                            onClick={() => this.sendRequest()}
                            disabled={!this.state.selectedMethod || this.state.loading}
                            className='pay-button'
                        >
                            {this.state.selectedMethod === 'freeCard' ? 'Pay with Freecard'.translate(this.props.lang) : 'Pay'.translate(this.props.lang)}
                        </Button>
                        <Button color="primary" className='red-button' onClick={() => this.onClose(null, true)}>{'Cancel'.translate(this.props.lang)}</Button>

                    </ModalFooter>
                </Modal>
                {
                    this.state.swishModal ?
                        <SwishModal
                            {...this.props}
                            isOpen={this.state.swishModal}
                            onClose={(callback) => {
                                this.setState({ swishModal: null }, () => {
                                    if (callback) callback();
                                });
                            }}
                            onSuccessfullyPayment={(callback) => {
                                this.setState({ swishModal: null }, () => {
                                    this.setSuccessModal('Payment successful', 'swish');
                                    if (callback) callback();
                                });
                            }}
                        />
                        :
                        null
                }
                {
                    this.state.stripeModal ?
                        <StripeModal
                            {...this.props}
                            isOpen={this.state.stripeModal}
                            onClose={(callback) => {
                                this.setState({ stripeModal: null }, () => {
                                    if (callback) callback();
                                });
                            }}
                            onSuccessfullyPayment={(callback) => {
                                this.setState({ stripeModal: null }, () => {
                                    this.setSuccessModal('Payment successful', 'stripe');
                                    if (callback) callback();
                                });
                            }}
                        />
                        :
                        null
                }
                {
                    this.state.paysonModal ?
                        <PaysonModal
                            {...this.props}
                            isOpen={this.state.paysonModal}
                            onClose={(callback) => {
                                this.setState({ paysonModal: null }, () => {
                                    if (callback) callback();
                                });
                            }}
                            onSuccessfullyPayment={(callback) => {
                                this.setState({ paysonModal: null }, () => {
                                    this.setSuccessModal('Payment successful', 'payson');
                                    if (callback) callback();
                                });
                            }}
                        />
                        :
                        null
                }
                {this.state.closeError ?

                    <ErrorModal lang={this.props.lang}
                        isOpen={this.state.closeError}
                        toggle={() => this.onClose()}

                    >
                        {this.state.closeError.translate(this.props.lang)}
                    </ErrorModal>

                    : null}


                {this.state.error ?

                    <ErrorModal lang={this.props.lang}
                        isOpen={this.state.error}
                        toggle={() => this.setState({ error: null })}

                    >
                        {this.state.error.translate(this.props.lang)}
                    </ErrorModal>

                    : null}

                {
                    this.state.successModal ?
                        <InfoModal
                            isOpen={this.state.successModal}
                            toggle={() => this.setState({ successModal: null })}
                            header={'Info'.translate(this.props.lang)}
                            info={this.state.successModal?.message?.translate(this.props.lang)}
                            buttons={[
                                <Button color='primary' onClick={() => {
                                    this.onClose(this.state.successModal?.callback)
                                }}>{'Close'.translate(this.props.lang)}</Button>
                            ]}
                        />
                        :
                        null

                }
                {
                    this.state.abortPaymentModal ?
                        <InfoModal
                            isOpen={this.state.abortPaymentModal}
                            header={'Warning'.translate(this.props.lang)}
                            info={this.state.abortPaymentModal?.message?.translate(this.props.lang)}
                            buttons={[
                                <Button
                                    color="primary"
                                    style={{ margin: 10 }}
                                    onClick={() => {
                                        if (this.state.abortPaymentModal?.callback) {
                                            this.state.abortPaymentModal.callback();
                                        }
                                    }}
                                >
                                    {'Ok'.translate(this.props.lang)}
                                </Button>
                            ]}

                        />
                        : null
                }
                {
                    this.state.removeCaseModal ?
                        <InfoModal
                            isOpen={this.state.removeCaseModal}
                            header={'Warning'.translate(this.props.lang)}
                            info={`If you cancel, your case will be deleted. Are you sure you want to continue?`.translate(this.props.lang)}
                            buttons={[
                                <Button
                                    color="primary"
                                    style={{ margin: 10 }}
                                    disabled={this.state.loadingRemoveCase}
                                    onClick={() => {
                                        this.removeUnpaidCase();
                                    }}
                                >
                                    {'Yes'.translate(this.props.lang)}
                                </Button>,
                                <Button
                                    color="primary"
                                    style={{ margin: 10 }}
                                    disabled={this.state.loadingRemoveCase}
                                    onClick={() => {
                                        this.setState({ removeCaseModal: false })
                                    }}
                                >
                                    {'No'.translate(this.props.lang)}
                                </Button>

                            ]}

                        />
                        : null
                }

            </>
        );
    }
}


export default PayModal;